<template>
  <lb-drawer
    :value="visible"
    @input="$emit('update:visible', $event)"
    heading="New Query"
    :width="drawerWidths.md"
    v-if="visible"
    data-testid="tasklist__helpdesk-drawer"
  >
    <template v-slot:body>
      <div class="d-flex align-center">
        <v-chip label class="caccounting--text lightpurple mr-2"
          ><span>{{ helpdeskItem.ref }}</span></v-chip
        >

        <div class="font-weight-bold px-1 align-center d-flex">
          <span>{{ helpdeskItem.description || '' }}</span>
        </div>
      </div>

      <div class="my-3">
        <span class="text-font-size-md gray--text my-2">Describe your request</span>
        <div class="text-field">
          <textarea
            class="input all-width border-on pa-2 radius-small"
            rows="4"
            cols="12"
            placeholder="Type the request here"
            :value="ticketDescription"
            @input="$emit('update:ticketDescription', $event.target.value)"
            data-testid="tasklist__helpdesk-description-textarea"
          />
        </div>
      </div>

      <span class="my-3 gray--text"
        >If you need Consark's assistance to complete this task or if you have any query relating to this tasklist
        item, you can submit this form to connect with our functional experts for quick resolution.</span
      >
      <div v-if="helpdeskItemNew">
        <v-btn
          v-if="(helpdeskItem.__existingtickets || []).length > 0"
          text
          data-testid="tasklist__helpdesk-back-to-existing-tickets-btn"
          class="shadow-off mb-2"
          @click="$emit('back-to-existing-tickets')"
          ><v-icon class="mr-1">mdi-arrow-left</v-icon><span>Back to existing tickets</span></v-btn
        >

        <div class="mt-3">
          <span class="font-weight-bold">Describe your request</span>
          <div class="text-field">
            <textarea
              class="input"
              rows="4"
              cols="12"
              placeholder="Type the request here"
              :value="ticketDescription"
              @input="$emit('update:ticketDescription', $event.target.value)"
              data-testid="tasklist__helpdesk-description-textarea"
            />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn
        v-if="showSubmit"
        @click="$emit('submit')"
        class="white--text black"
        data-testid="tasklist__helpdesk-submit-btn"
        ><span>Submit</span></v-btn
      >
    </template>
  </lb-drawer>
</template>

<script>
import { drawerWidths } from '../../../../../../../styles/design-tokens.js';

export default {
  name: 'HelpdeskQueryDrawer',
  data() {
    return { drawerWidths };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    helpdeskItem: {
      type: Object,
      default: () => ({}),
    },
    ticketDescription: {
      type: String,
      default: '',
    },
    helpdeskItemNew: {
      type: Boolean,
      default: false,
    },
    showSubmit: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
